"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const RoleSectionContent_vue_1 = __importDefault(require("../../roleSectionTemplate/components/RoleSectionContent.vue"));
const roleStore_1 = require("../../store/v1/roleStore");
const vue_3 = require("vue");
const roleParser_1 = require("../../legacy/parser/roleParser");
const roleSectionInjectionKeys_1 = require("../../roleSectionTemplate/types/roleSectionInjectionKeys");
const GroupRoleBranchModal_vue_1 = __importDefault(require("../../view/components/groupRole/components/GroupRoleBranchModal.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'RolesView',
    props: {
        roles: {
            type: Array,
            required: true,
        },
        meStore: {
            type: Object,
            required: true,
        }
    },
    setup(__props) {
        const isGroupSectionPage = (0, vue_3.inject)(roleSectionInjectionKeys_1.GroupRoleSectionInjectionKey, false);
        const groupRoleBranchModal = (0, vue_3.ref)(null);
        const props = __props;
        const roleStore = (0, vue_3.ref)(new roleStore_1.RoleStore());
        function initRoleStore() {
            props.roles.forEach((role) => {
                roleStore.value.add(role);
            });
        }
        function addRoleSection(role) {
            const parsedRole = (0, roleParser_1.parseFromRaw)(role);
            roleStore.value.add(parsedRole);
        }
        function deleteRoleSection(roleId) {
            roleStore.value.delete(roleId);
        }
        function openGroupRoleBranchModal(roleId) {
            groupRoleBranchModal.value?.openModal(roleId);
        }
        function setNewGroupRoleBranch(roleId) {
            groupRoleBranchModal.value?.setNewGroupRoleBranch(roleId);
        }
        initRoleStore();
        (0, vue_3.provide)(roleSectionInjectionKeys_1.RoleViewInjectionKey, {
            addRoleSection,
            deleteRoleSection,
        });
        (0, vue_3.provide)(roleSectionInjectionKeys_1.GroupRoleSectionViewInjectionKey, {
            openGroupRoleBranchModal,
            setNewGroupRoleBranch,
        });
        (0, vue_3.provide)(roleSectionInjectionKeys_1.RoleViewMeStore, props.meStore);
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                ((0, vue_2.unref)(isGroupSectionPage))
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(GroupRoleBranchModal_vue_1.default, {
                        key: 0,
                        ref_key: "groupRoleBranchModal",
                        ref: groupRoleBranchModal
                    }, null, 512 /* NEED_PATCH */))
                    : (0, vue_2.createCommentVNode)("v-if", true),
                (0, vue_2.createVNode)(RoleSectionContent_vue_1.default, {
                    "role-store": roleStore.value,
                    "me-store": props.meStore
                }, null, 8 /* PROPS */, ["role-store", "me-store"])
            ], 64 /* STABLE_FRAGMENT */));
        };
    }
});
